import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class CustomOrderPlanningConfigurationSelectListComponent implements IController {
  options: any;
  selectedId: any;
  optionIds: string[];
  ngPlaceholder: any;
  excludeIds: any;
  onChange: Function;


  private orderPlanningConfigurationRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  public excludedMap: any;

  constructor(private $orderPlanningConfiguration, private $infiniteScroll, private $log) {
  }

  $onInit() {
    this.orderPlanningConfigurationRef = this.$orderPlanningConfiguration();

    if (!this.options) {
      this.loadLimit = 100;
      this.orderPlanningConfigurationRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.orderPlanningConfigurationRef, this.loadLimit, {getFullData: true});
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.options) {
      this._reload();
    }
  }

  private _reload() {
    this.orderPlanningConfigurationRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit:  this.loadLimit,
      query:  this.queryString,
    };
  }
}

angular
  .module('bringoz.admin.order-planning-configuration')
  .component('customOrderPlanningConfigurationSelectList', {
    bindings: {
      options: '<?',
      optionIds: '<?',
      selectedId: '<',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./custom-order-planning-configuration-select-list.html').default,
    controller: CustomOrderPlanningConfigurationSelectListComponent
  });
